export const heart = ({ color = "black", className}) => {
    return (
        <svg
	 width="28" 
     height="25" 
     viewBox="0 0 437.775 437.774" 
     fill="#262626" 
     className={className} 
     
	 >
    <path d="M316.722,29.761c66.852,0,121.053,54.202,121.053,121.041c0,110.478-218.893,257.212-218.893,257.212S0,266.569,0,150.801
		C0,67.584,54.202,29.761,121.041,29.761c40.262,0,75.827,19.745,97.841,49.976C240.899,49.506,276.47,29.761,316.722,29.761z"
        fill={color}
        stroke="#333333"
        strokeWidth="5%"
        />
        </svg>
    )
}
